import { useMessagesRepository } from '@Hooks/useRepository';
import { type ApiNotification } from '@Model';
import { NotificationsRepository } from '@Repositories/Messages';
import { type ListInfo, unwrapOr } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

export function useUnreadNotificationsCount() {
    const notifications = useMessagesRepository(NotificationsRepository);

    const { data, refetch: refetchQuery } = useQuery({
        queryKey: ['notifications', 'unread-count'],
        queryFn: async () => {
            const result = await notifications.query(0, 0, true);
            return unwrapOr(result, { total_item_count: 0 } as ListInfo<ApiNotification>).total_item_count;
        },
        refetchOnWindowFocus: false,
    });

    const refetch = useCallback(() => {
        void refetchQuery();
    }, [refetchQuery]);

    return { unreadCount: data ?? 0, refetch };
}
